<template>
  <div>
    <!-- Mask Overlay -->
    <div v-if="isOpen" class="cart-mask" @click="closeCart"></div>

    <!-- Cart Drawer -->
    <div :class="['cart-drawer', { 'open': isOpen }]">
      <div class="cart-header">
        <div v-if="currentTitle==='Profile'" class="sidebar-header" >
          <div style="display: flex;gap: 10px;padding: 20px 0;">
              <!-- Logo Section -->
              <div style="padding: 0;" class=" logo-section text-center">
                  <!-- Placeholder for the logo, could use initials or an SVG here -->
                  <div class="logo-circle">
                    {{ name?.split(' ')?.[0]?.charAt(0)?.toUpperCase() || '' }}{{ name?.split(' ')?.[1] 
                    ? name?.split(' ')?.[1]?.charAt(0)?.toUpperCase()
                    : name?.split('')?.[1]?.charAt(0)?.toUpperCase() || '' }}
                  </div>
              </div>

              <!-- User Info Section -->
              <div class="user-info text-left" style="padding: 0;">
                  <p class="username">{{ name.toUpperCase() }}</p>
                  <p class="status" style="margin: 0;">
                      <span v-if="type == 0">PC: {{ mca_no }}</span>
                      <span v-else>Advisor: {{ mca_no }}</span>
                  </p>
              </div>
          </div>
        </div>
        <h2 v-else>{{ currentTitle }}</h2>
         <!-- Logout Button -->
         <div class="text-right logout-section">
            <div @click="closeCart" v-if="(currentTitle !='KYC Update' && currentTitle !='Select Address' && currentTitle !='Promotions')" class="close_icon">
              <span style="font-size: 12px;">X</span>
            </div>
        </div>
      </div>
      <div class="cart-content" style="padding: 10px 20px 30px;">
        <!-- Conditionally render components based on the title -->
        <div v-if="currentTitle === 'Shopping Cart'">
          <CartDrawer />
        </div>
        <div v-else-if="currentTitle === 'Notifications'">
          <Notification />
        </div>
        <div v-else-if="currentTitle === 'Select Address'">
          <AddressListSelect :onLogin="true"/>
        </div>
        <div v-else-if="currentTitle === 'Change Address'">
          <AddressListSelect />
        </div>
        <div v-else-if="currentTitle === 'Address Details'">
          <NewAddressForm :address="propsdata" />
        </div>
        <div v-else-if="currentTitle === 'Promotions'">
          <OfferListSelect :checkFirst="propsdata"/>
        </div>
        <div v-else-if="currentTitle === 'Profile'">
          <ProfilePanel/>
        </div>
        <div v-else-if="currentTitle === 'My Addresses'">
          <ProfilePanel/>
        </div>
        <div v-else-if="currentTitle === 'Address Form'">
          <ProfilePanel/>
        </div>
        <div v-else-if="currentTitle === 'KYC Update'">
          <MigrateUserKYC/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { onMounted, ref, reactive, computed } from 'vue';
import CartDrawer from '@/components/prelogin/CartDrawer.vue';
import Notification from '@/components/common/NotificationList.vue';
import eventBus from '@/utils/eventBus';
import AddressListSelect from './AddressListSelect.vue';
import NewAddressForm from './NewAddressForm.vue';
import ProfilePanel from './ProfilePanel.vue';
import OfferListSelect from './OfferListSelect.vue';
import { useUserStore } from '@/stores/userStore';
import { useCartStore } from '@/stores/cart';
import { showToast } from '@/utils/toaster';
import router from '@/router';
import MigrateUserKYC from './MigrateUserKYC.vue';
// import ProfileNew from '@/pages/postlogin/ProfileNew.vue';
export default {
  components: {
    CartDrawer,
    Notification,
    AddressListSelect,
    NewAddressForm,
    OfferListSelect,
    ProfilePanel,
    MigrateUserKYC
  },
  setup() {
    const isOpen = ref(false);
    const currentTitle = ref('Shopping Cart');  // Default title
    const propsdata = reactive({
    });
    const userStore = useUserStore();
    const cartStore = useCartStore();
    const mca_no  =  computed(()=>userStore.mcano);
    const type  =  computed(()=>userStore.getuserType);
    onMounted(()=>{
      eventBus.panelOpen = (title,propdatas={}) => {
        if(propdatas?.address){
          propsdata.value = propdatas?.address;
        }else if(title=='Promotions'){
          cartStore.setOfferModalStatus(1);
        }
        else{
          propsdata.value = propdatas;
        }
      console.log(propdatas,"panelopen",title);
      isOpen.value = true;
      currentTitle.value = title || 'Shopping Cart';  // Use provided title or fallback to default
      document.body.style.overflowY="hidden"
    };
    
      
      eventBus.panelClose = () => {
        if(currentTitle.value == "Select Address") {
          cartStore.updateCartActions(mca_no,true)
        }
        isOpen.value = false;
        document.body.style.overflowY="visible";
        // setTimeout(
          currentTitle.value = 'Shopping Cart'
          // ,2000)
      };
    })

    const closeCart = () => {
      if(currentTitle.value!="KYC Update" && currentTitle.value !='Select Address'){
        eventBus.panelClose();
        document.body.style.overflowY="visible"
      }else{
        showToast('selectAddress');
      }
    };

    function logout() {
      userStore.destroySession();
      cartStore.clearCart()
      cartStore.destroyCart();
      // showToast('loggedOut');
      closeCart()
      window.location.href = '/';
      closeCart();
      router.push('/');
    }

    const name = computed(() => userStore.getuserName);

    return {
      isOpen,
      currentTitle,
      closeCart,
      propsdata,
      logout,
      name,
      mca_no,
      type
    };
  }
}
</script>



<style scoped>
  @media (max-width:768px){
  .delete-product{
    left: calc(14px + 33vw) !important;
  }
  }
  .delete-product{
    position:relative;top: 30px;left: calc(10vw - 0px) ;width: fit-content;background: none;border: none;
  }
  .font-2{
    font-family: 'Raleway',sans-serif;
  }
  .dropdown-menu {
    position: absolute;
    background: white;
    border: 1px solid #ccc;
    padding: 10px;
    z-index: 1000;
  }

  .dropdown-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .dropdown-menu li {
    padding: 5px 10px;
    cursor: pointer;
  }

  .dropdown-menu li:hover {
    background-color: #f0f0f0;
  }

  .cart-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
  }

  .cart-drawer {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 233200;
    transition: right 0.3s ease;
  }

  .cart-drawer.open {
    right: 0;
  }

  @media (min-width: 1024px) {
    .cart-drawer {
      width: 30%;
    }
  }

  @media (min-width: 768px) and (max-width:1024px) {
    .cart-drawer {
      width: 50%;
    }
  }

  .cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
  }

  .cart-content {
    height: 80vh;
    overflow-y: auto;
    padding: 20px;
  }

  .cart-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    padding-left: 12px;
  }

  .cart-item {
    background-color: rgb(255, 255, 255);
    border-style: solid;
    border-width: 1px;
    border-color: rgba(0, 19, 37, 0.08);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
    min-width: 100%;
  }

  .item-details {
    display: flex;
    text-align: left;
    flex-direction: column;
    margin-left: 15px;
  }

  .checkout-btn {
    background-color: #002f6c;
    color: white;
    padding: 10px 15px;
    width: 100%;
    border: none;
    border-radius: 5px;
  }

  .view-cart-btn {
    background-color: transparent;
    color: #002f6c;
    padding: 10px 15px;
    width: 100%;
    border: none;
    margin-top: 10px;
  }

  .css-2vxg6l {
    display: flex;
    flex-direction: row;
    border-style: solid;
    border-width: 1px;
    border-color: rgba(0, 19, 37, 0.08);
    background: rgb(255, 255, 255);
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 60px;
  }

  .css-15vhhhd {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 100%;
  }

  .css-esow25 {
    display: flex;
    flex-direction: column;
    padding: 4px 10px 4px 20px;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 100%;
  }

  .css-15py5ir {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: justify;
    justify-content: space-between;
    text-align: left;
    padding-top: 8px;
  }

  .css-1um1mkq {
    color: rgb(0, 19, 37);
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.1px;
    margin: unset;
  }

  .css-1myqv6q {
    display: flex;
    text-wrap: nowrap;
    flex-direction: row;
    padding-bottom: 5px;
  }

  .css-1lxsyb2 {
    color: rgb(0, 19, 37);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0px;
    margin: unset;
  }

  .css-175whwo {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    cursor: pointer;
  }

  .css-18zwcko {
    display: flex;
    flex-direction: column;
    padding: 8px 20px 8px 10px;
    width: 100%;
  }

  .css-f1qhpj {
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 12px;
    border-style: solid;
    border-width: 1px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.1px;
    border-color: rgb(0 48 108);
    background-color: rgb(0 48 108);
    color: rgb(255, 255, 255);
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
    width: 100%;
    gap: 3px;
  }

  .css-18zwcko button {
    padding: 0px 12px;
    height: 50px;
    width: 200px;
  }

  .css-15vhhhd {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: justify;
    justify-content: space-between;
    width: 100%;
  }

  .css-207d6f {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  .css-1l4d0ex {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.1px;
    margin: unset;
  }

  .css-1nh9xit {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0px;
    margin: unset;
  }

  .css-1aowomc {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }
  .username {
    color: #354657;
    font-family: "Raleway", sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    overflow: hidden;
    text-transform: capitalize;
    margin: 0;
}

.logo-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #006ea5;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
}

.logout-section {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.close_icon {
  position:relative;
  z-index:324;
  cursor: pointer;
  background-color: #c0b9b94d;
  /* right: -11px; */
  top: -5px;
  float:right;
  border-radius: 100%;
  display: flex;
  justify-content: center; 
  padding: 14px;
  width: 6px;
  height: 6px;
  align-items: center;
  border: none;
}
</style>